import { handleKeyDown } from "../../utils/utils";


type UploadFromPhoneButtonProps = {
    onClick: () => void;
    };

export default function UploadFromPhoneButton({onClick}: Readonly<UploadFromPhoneButtonProps>) { 
    return(
        <div className='p-x-md file-upload-mobile' onClick={onClick} role="button" tabIndex={0} onKeyDown={(e) => handleKeyDown(e)} style={{borderColor: "#4D4D4D"}}>
        <div className='form-label'>
          <i className='icon-smartphone fz-xl' />
          <p className="text fw-medium">
          Vos documents ne sont pas sur votre appareil
          </p>
          <div>
            <p className="fz-xs bleu">Prenez une photo ou sélectionnez un fichier depuis votre smartphone</p>
          </div>
         
          </div>
      </div>
    )
}